import { useEffect, useState } from "react";

import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useBookDemoLink } from "@src/hooks/useBookDemoLink";
import { salesNudgeBookDemoLink } from "@src/utils/linkSheet";
import { mpBookDemoClick, mpSalesNudgeViewed } from "@src/utils/mixpanel";

import type { BillingStatusContent } from "@src/components/MainApp/Alerts/useBillingStatusContent";
import { TrialSalesNudgeView } from "./TrialSalesNudge.view";

const SALES_NUDGE_SOURCE = "trial_nudge";

export const TrialSalesNudge = ({
  content,
}: {
  content: BillingStatusContent;
}) => {
  const isAdmin = useIsAdmin();
  const bookDemoLink = useBookDemoLink(
    salesNudgeBookDemoLink,
    SALES_NUDGE_SOURCE
  );
  const [isMinimized, setIsMinimized] = useState(false);
  const [showAfterDelay, setShowAfterDelay] = useState(false);
  const isVisible = showAfterDelay && !isMinimized;

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAfterDelay(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isVisible) {
      mpSalesNudgeViewed(SALES_NUDGE_SOURCE);
    }
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <TrialSalesNudgeView
      content={content}
      onBookSalesCall={() => {
        mpBookDemoClick(SALES_NUDGE_SOURCE);
        window.open(bookDemoLink, "_blank", "noopener,noreferrer");
      }}
      onDismiss={isAdmin ? () => setIsMinimized(true) : undefined}
    />
  );
};
